import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { size } from 'lodash';
import { FlashMessage } from '@src/components/FlashMessage';
import { getFlashMessages } from '@src/redux/selectors/flashMessages';
import { removeFlashMessage } from '@src/redux/actions/flashMessages';
import './styles.scss';

const FLASH_MESSAGE_TIMEOUT = 5000;

@connect(
  state => ({
    flashMessages: getFlashMessages(state),
  }),
  {
    removeFlashMessage,
  },
)
export class FlashMessagesContainer extends Component {
  static propTypes = {
    flashMessages: PropTypes.array.isRequired,
    removeFlashMessage: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    const { flashMessages, removeFlashMessage } = props;

    if (size(flashMessages) > 0) {
      flashMessages.forEach(flashMessage => {
        if (!flashMessage.shouldDisableAutoHide) {
          setTimeout(() => removeFlashMessage(flashMessage.id), FLASH_MESSAGE_TIMEOUT);
        }
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { flashMessages, removeFlashMessage } = this.props;

    if (size(prevProps.flashMessages) < size(flashMessages)) {
      const newestFlashMessage = flashMessages[size(flashMessages) - 1];

      if (!newestFlashMessage.shouldDisableAutoHide) {
        setTimeout(() => removeFlashMessage(newestFlashMessage.id), FLASH_MESSAGE_TIMEOUT);
      }
    }
  }

  render() {
    const { flashMessages, removeFlashMessage } = this.props;

    return (
      <div className="flash-messages-container">
        <TransitionGroup>
          {flashMessages.slice(0, 5).map(({ id, title, message, type, link, linkLabel, to }) => {
            return (
              <CSSTransition classNames="flash" key={id} timeout={300}>
                <FlashMessage
                  close={() => removeFlashMessage(id)}
                  link={link}
                  linkLabel={linkLabel}
                  message={message}
                  title={title}
                  to={to}
                  type={type}
                />
              </CSSTransition>
            );
          })}
        </TransitionGroup>
      </div>
    );
  }
}

export default FlashMessagesContainer;
